var _circle, _path, _path2, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 18.4H16.6667C16.9428 18.4 17.1667 18.1761 17.1667 17.9V9.30711C17.1667 9.1745 17.114 9.04732 17.0203 8.95355L14.2132 6.14645C14.1194 6.05268 13.9922 6 13.8596 6H7.33337C7.05723 6 6.83337 6.22386 6.83337 6.5V17.9C6.83337 18.1761 7.05723 18.4 7.33337 18.4Z",
    fill: "#2D2E33",
    stroke: "#2D2E33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9908 8.99083L14.3536 6.35355C14.2231 6.22308 14 6.31549 14 6.5V9.11667C14 9.39281 14.2239 9.61667 14.5 9.61667H16.7316C17.0582 9.61667 17.2218 9.22178 16.9908 8.99083Z",
    fill: "#979799",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 12.5,
    x2: 14.5,
    y2: 12.5,
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 14.5,
    x2: 14.5,
    y2: 14.5,
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsLogo);
export default __webpack_public_path__ + "static/media/docs-logo.2f781132.svg";
export { ForwardRef as ReactComponent };